import { Role } from '@/core/components/auth/auth.types'
import { organizationQueryOptions } from '@/core/components/organizations/organizationQueryOptions'
import { propertiesQueryOptions } from '@/core/components/sites/propertyQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/dashboard/users/create-user/')({
  beforeLoad: ({ context: { auth } }) => {
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger'] ||
      auth.user?.role === Role.PropertyManager
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth } }) => {
    const properties = queryClient.ensureQueryData(
      propertiesQueryOptions(auth.token!)
    )
    const organizations = queryClient.ensureQueryData(
      organizationQueryOptions(auth.token!)
    )

    return {
      properties,
      organizations,
    }
  },
})
